const __WEBPACK_NAMESPACE_OBJECT__ = SingleVendor.qrcode;